var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "room-group-video-film-container" },
    [
      _c(
        "div",
        { staticClass: "room-group-video-body" },
        _vm._l(_vm.roomGroup.roomUserVideos, function (ruv) {
          return _c("RoomCallMixingVideo", {
            key: ruv.userId,
            ref: `videos_group_user${ruv.userId}`,
            refInFor: true,
            attrs: {
              "video-rect": ruv,
              "room-group-id": _vm.roomGroup.roomGroupId,
              "mixer-video": true,
            },
          })
        }),
        1
      ),
      !_vm.isInRoomGroup()
        ? [
            _vm.showRoomGroupVideoFilmHeader
              ? _c("RoomGroupVideoFilmHeader", {
                  attrs: { roomGroup: _vm.roomGroup },
                  on: {
                    close: () => (this.showRoomGroupVideoFilmHeader = false),
                  },
                })
              : _c("div", { staticClass: "room-group-show-film-header" }, [
                  _c("button", {
                    staticClass: "room-group-btn-show-film-header",
                    on: {
                      click: () => (this.showRoomGroupVideoFilmHeader = true),
                    },
                  }),
                ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }